// src/constants/characterTags.ts
// キャラクタータグのマスターデータ
// 絞り込みや作成フォームで使用

export const CHARACTER_TAGS = {
  // ジャンル（キャラクターの種類）
  genre: {
    label: 'ジャンル',
    options: [
      { value: '人間', label: '人間' },
      { value: '人外', label: '人外' },
      { value: '動物', label: '動物' },
      { value: 'ケモノ', label: 'ケモノ' },
      { value: '擬人化', label: '擬人化' },
      { value: 'クリーチャー', label: 'クリーチャー' },
      { value: 'メカ・ロボ', label: 'メカ・ロボ' },
      { value: 'マスコット', label: 'マスコット' },
    ],
  },

  // 性格
  personality: {
    label: '性格',
    options: [
      { value: '明るい', label: '明るい' },
      { value: 'クール', label: 'クール' },
      { value: '天然', label: '天然' },
      { value: '真面目', label: '真面目' },
      { value: 'ダウナー', label: 'ダウナー' },
      { value: 'ツンデレ', label: 'ツンデレ' },
      { value: 'ミステリアス', label: 'ミステリアス' },
      { value: 'おっとり', label: 'おっとり' },
      { value: '元気', label: '元気' },
      { value: '甘えん坊', label: '甘えん坊' },
    ],
  },

  // 世界観
  worldview: {
    label: '世界観',
    options: [
      { value: 'ファンタジー', label: 'ファンタジー' },
      { value: '現代', label: '現代' },
      { value: 'SF', label: 'SF' },
      { value: '和風', label: '和風' },
      { value: '日常系', label: '日常系' },
    ],
  },
} as const;

// 型定義
export type GenreTag = typeof CHARACTER_TAGS.genre.options[number]['value'];
export type PersonalityTag = typeof CHARACTER_TAGS.personality.options[number]['value'];
export type WorldviewTag = typeof CHARACTER_TAGS.worldview.options[number]['value'];
export type CharacterTag = GenreTag | PersonalityTag | WorldviewTag;

// ヘルパー関数: タグからカテゴリを取得
export function getTagCategory(tag: string): 'genre' | 'personality' | 'worldview' | null {
  if (CHARACTER_TAGS.genre.options.some(o => o.value === tag)) return 'genre';
  if (CHARACTER_TAGS.personality.options.some(o => o.value === tag)) return 'personality';
  if (CHARACTER_TAGS.worldview.options.some(o => o.value === tag)) return 'worldview';
  return null;
}

// ヘルパー関数: 全タグの配列を取得
export function getAllTags(): string[] {
  return [
    ...CHARACTER_TAGS.genre.options.map(o => o.value),
    ...CHARACTER_TAGS.personality.options.map(o => o.value),
    ...CHARACTER_TAGS.worldview.options.map(o => o.value),
  ];
}

// ヘルパー関数: カテゴリ別のタグ値配列を取得
export function getTagsByCategory(category: 'genre' | 'personality' | 'worldview'): string[] {
  return CHARACTER_TAGS[category].options.map(o => o.value);
}
